import logoUrl from '../assets/eperformances-logo.png';

export default function BrandLogo({ className = 'h-5 sm:h-6' }: { className?: string }) {
  return <img src={logoUrl} alt="ePerformances" className={`block w-auto ${className}`} />;
}
